import { UiOption } from '@/lib/helpers';

export const getEmailDomainOptions = (domains: string[]): UiOption[] =>
  [...new Set(domains)].map((domain) => ({
    label: `@${domain}`,
    value: domain,
  }));
